import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { useGlobalContext } from '../../context/GlobalContext';
import { Operators } from '../../enum/operators.enum';
import buildUserAccessPredicate from '../../hooks/use-build-user-acess.hook';
import { IUnidadeCleanDTO, IWebinarFullDTO } from '../../models/happy-code-api.model';
import { Predicate } from '../../models/predicate.model';
import { PageableResponse } from '../../models/response.model';
import { useAcaWebinarService } from '../../services/aca-webinar';
import { useUnidadeService } from '../../services/unidade.service';
import { getLocalStorageItem } from '../../util/store';

export default function useWebinarsAll() {
  const { setIsGlobalLoading, usuario, unidade } = useGlobalContext();
  const unidadeService = useUnidadeService();

  const [pageNumber, setPageNumber] = useState<number | null>(null);

  const [search, setSearch] = useState('');

  const [webinarsPage, setWebinarsPage] =
    useState<PageableResponse<IWebinarFullDTO>>();

  const webinarsService = useAcaWebinarService();

  const findTipoUnidadeByUnidadeId = useCallback(async (): Promise<number> => {
    setIsGlobalLoading(true);
    return unidadeService
      .findById({ id: unidade?.id })
      .then(({ data }) => {
        return data.tipoUnidade.id;
      })
      .finally(() => setIsGlobalLoading(false));
  }, [unidade]);

  const addPredicateOptions = useCallback(async () => {
    const predicate = new Predicate();

    predicate.removeAllOption();
    predicate.size = 16;
    predicate.addOption('ativo', true);

    const { unidadeTipoUnidadeCodigo } = getLocalStorageItem("@HappyCodeAcademy/login/unidade") as IUnidadeCleanDTO;

    if(unidade?.id){
      if (unidadeTipoUnidadeCodigo.toLowerCase() !== 'angola' && unidadeTipoUnidadeCodigo.toLowerCase() !== 'paraguai') {
      const tipoUnidadeId = await findTipoUnidadeByUnidadeId();
      predicate.addOption('tipoUnidade.id', tipoUnidadeId);
    } else {
      predicate.addMultiOption('tipoUnidade.id', 1, Operators.OR);
      predicate.addMultiOption('tipoUnidade.id', 3, Operators.OR);
    }
    }
    

    if (search) predicate.addOption('nome', search, Operators.CONTAINS);

    if (pageNumber) predicate.setPage(pageNumber);

    return predicate;
  }, [pageNumber, search]);

  const findWebinar = useCallback(async () => {
    setIsGlobalLoading(true);

    const predicate = await addPredicateOptions();
    const finalPredicate = buildUserAccessPredicate(usuario, predicate);

    webinarsService
      .findFullCustom(finalPredicate)
      .then(({ data }) => setWebinarsPage(data))
      .finally(() => setIsGlobalLoading(false));
  }, [addPredicateOptions, setIsGlobalLoading, usuario]);

  useEffect(() => {
    findWebinar();
  }, [findWebinar, unidade, pageNumber]);

  const onPageChange = (event: ChangeEvent<unknown>, page: number) => {
    event.preventDefault();
    setPageNumber(page);

  };

  const webinarTitle = webinarsPage?.totalElements || 0;

  return {
    webinarsPage,
    search,
    setSearch,
    onPageChange,
    webinarTitle,
  };
}
